/* Hey Hottie — corrects Appstle's perks tooltip  (v1)
 *
 * Appstle's widget carries a merchant-editable blurb, reached by tapping
 * "Hottie Subscription Perks" on the product page. It still describes the plan
 * we replaced:
 *
 *   "…every month, every 2 months, or every 3 months … Skip, reschedule, or
 *    edit your subscription anytime—you're always in control"
 *
 * Every clause of that is now false. The plan is every 4 or 8 weeks, there is
 * one skip inside a four-order minimum, and cancelling is by email. A shopper
 * who taps it is reading a promise the checkout will not keep.
 *
 * The right fix is the app's own setting. This is the seatbelt: it rewrites
 * the tooltip ONLY while the old wording is still there, so the moment someone
 * corrects it inside Appstle this file stops touching anything. It never edits
 * text it does not recognise.
 *
 * Appstle renders its widget asynchronously and re-renders on variant change,
 * so this watches rather than running once. */
(function () {
  'use strict';

  var STALE = /every 2 months|every 3 months|always in control|subscription anytime/i;

  var TRUE_COPY =
    'Pick every 4 weeks or every 8 weeks and save 25% on every order — not just the first. ' +
    'Your first four orders are the commitment, and you can skip one of them. ' +
    'Change the date, the items or how often it comes yourself in your account. ' +
    'To cancel, email us at heyhottiecosmetics@gmail.com and we’ll take care of it.';

  function fix() {
    var nodes = document.querySelectorAll('.appstle_tooltip_content');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('data-hh-fixed') === '1') continue;
      if (!STALE.test(el.textContent || '')) continue;

      /* Keep whatever heading Appstle put at the top; replace the prose under
         it. If there is no heading, the whole block becomes the prose. */
      var head = el.querySelector('strong, b, h3, h4');
      var p = document.createElement('span');
      p.className = 'hh-appstle-copy';
      p.textContent = TRUE_COPY;

      el.innerHTML = '';
      if (head) el.appendChild(head);
      el.appendChild(p);
      el.setAttribute('data-hh-fixed', '1');
    }
  }

  function start() {
    fix();
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function () { fix(); });
    mo.observe(document.body, { childList: true, subtree: true });
    /* Stop watching after a while — the widget has long settled by then and a
       permanent observer on the whole body is not a thing to leave running. */
    setTimeout(function () { mo.disconnect(); fix(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
